import { getStorageKey } from "common/constants";

export function getLocalCache<T>(key: string): T | null {
  try {
    const item = localStorage.getItem(getStorageKey(key));
    if (item) {
      return JSON.parse(item) as T;
    }
  } catch (error) {
    console.error(
      `Error retrieving item from localStorage with key "${key}":`,
      error
    );
  }
  return null;
}

export function setLocalCache<T>(key: string, value: T): void {
  try {
    localStorage.setItem(getStorageKey(key), JSON.stringify(value));
  } catch (error) {
    console.error(
      `Error setting item in localStorage with key "${getStorageKey(key)}":`,
      error
    );
  }
}
